import { ScreenComponent } from 'new/routes/RouterManager';
import EditQuarantineFormContainer from 'js/components/settings/EditQuarantineFormContainer';
import React from 'react';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_MONITOR } from 'new/constants/pathnames';
import { ErrorDataSettings } from 'new/components/monitor/ErrorDataSettings';
import { ModalFilePreview } from 'new/elements/ModalFilePreview';

export const EditErrorDataSettings: ScreenComponent<any> = () => (
  <EditQuarantineFormContainer
    // @ts-ignore
    redirectPath={ErrorDataSettings.screenConfig.path}
  />
);

EditErrorDataSettings.screenConfig = {
  screenName: 'EditErrorDataSettings',
  path: `${ROUTE_REDESIGN}${ROUTE_MONITOR}/error-data-settings-config`,
  modals: [ModalFilePreview],
  domain: 'monitor',
};
